import queryString from 'query-string';

type Query = {
  key: string;
  value: string;
};

function stringifyUrl(url: string) {
  return encodeURIComponent(url);
}

function stringifyParams(params: Query) {
  return queryString.stringify(params);
}

function parseUrl(url: string) {
  return decodeURIComponent(url);
}

function parseParams(params: string) {
  return queryString.parse(params);
}

const linking = {
  prefixes: [
    'https://mobile.youtopin.com/',
    'http://127.0.0.1:3000/',
    'youtopin:/',
  ],
  config: {
    screens: {
      Root: {
        path: '',
        screens: {
          Root: '',
          TourFilterModal: '',
        },
      },
      TourFilterModal: 'tours/filter',
      Authentication: '/',
      SignUpPhone: 'authentication/sign-up/phone',
      SignIn: {
        path: 'authentication/sign-in/',
        screens: {
          SignInPhone: 'phone',
          SignInUsername: 'username',
        },
      },
      ForgetPassword: {
        path: 'authentication/forget',
        screens: {
          ForgetPasswordPhone: 'phone',
          ForgetPasswordUsername: 'username',
        },
      },
      SetupTalents: 'setup/talents',
      SetupTravelingPreference: 'setup/traveling',
      SetupLabels: 'setup/labels',
      SetupPrime: 'setup/prime',
      SetupUsernamePassword: 'setup/username-password',
      SetupUserInfo: 'setup/user-info',
      Introduction: 'introduction',
      PrimeHome: 'prime',
      PrimePlans: 'prime/plans/',
      PrimeLibrary: 'prime/library',
      PrimeBook: 'prime/book/:id',
      PrimeBookTextReader: 'prime/book/:id/read',
      PrimeBookAudioReader: 'prime/book/:id/listen',
      PrimeBookMenu: 'prime/book/:id/menu',
      PrimeTripAdvisor: 'prime/tripAdvisor',
      ImmigrationHome: 'Immigration',
      ImmigrationPlans: 'Immigration/plans/:primeId/:result',
      ImmigrationLibrary: 'Immigration/library',
      ImmigrationBook: 'Immigration/book/:id',
      ImmigrationBookTextReader: 'Immigration/book/:id/read',
      ImmigrationBookAudioReader: 'Immigration/book/:id/listen',
      ImmigrationBookMenu: 'Immigration/book/:id/menu',
      ImmigrationTripAdvisor: 'Immigration/tripAdvisor',
      Journey: 'journey/:id',
      Post: 'post/:id',
      Tour: 'tour/:id',
      Hashtag: 'hashtag/:name',
      Search: {
        path: 'search',
        screens: {
          Places: ':q',
          People: 'people/:q',
          Hashtags: 'hashtags/:q',
        },
      },
      Collection: 'collection/:id',
      Drawer: {
        path: '/',
        screens: {
          Dashboard: {
            path: 'dashboard',
            screens: {
              HomeStack: {
                path: '/',
                screens: {
                  Home: '',
                },
              },
              ToursStack: {
                path: 'tours',
                screens: {
                  TourHome: '',
                },
              },
              ExploreStack: {
                path: 'explore',
                screens: {
                  Explore: '',
                },
              },
              NotificationsStack: {
                path: 'notifications',
                screens: {
                  Notifications: '',
                },
              },
              ActivitiesStack: {
                path: 'activities',
                screens: {
                  Activities: '',
                },
              },
            },
          },
          HeroesStack: {
            path: 'heroes',
            screens: {
              Heroes: {
                path: '/',
                screens: {
                  Competition: '',
                  All: 'all',
                  Friends: 'friends',
                  Monthly: 'monthly',
                },
              },
            },
          },
          WalletStack: {
            path: 'wallet',
            screens: {
              Wallet: '',
            },
          },
          Settings: {
            path: 'setting',
            screens: {
              Setting: '',
            },
          },
          AddLocation: {
            path: 'location/add',
            screens: {
              AddLocation: '',
            },
          },
        },
      },
      Profile: 'profile/:id?',
      ProfileEdit: 'profile/:id/edit',
      ProfileFollowings: 'profile/:id/following',
      ProfileFollowers: 'profile/:id/followers',
      Location: 'location/:id',
      Camps: 'camps',
      NewPost: 'post/new/:businessId/:journeyId/:mediaId',
      Support: 'support/:uri',
      PickLocation: 'location/pick',
      Tours: {
        path: 'tours/:title/:url/:params?',
        parse: {
          url: parseUrl,
          params: parseParams,
        },
        stringify: {
          url: stringifyUrl,
          params: stringifyParams,
        },
      },
      PrimeBooks: {
        path: 'prime/books/:title/:url/:params?',
        parse: {
          url: parseUrl,
          params: parseParams,
        },
        stringify: {
          url: stringifyUrl,
          params: stringifyParams,
        },
      },
      Posts: {
        path: 'posts/:title/:url/:params?',
        parse: {
          url: parseUrl,
          params: parseParams,
        },
        stringify: {
          url: stringifyUrl,
          params: stringifyParams,
        },
      },
      Users: {
        path: 'users/:title/:url/:params?',
        parse: {
          url: parseUrl,
          params: parseParams,
        },
        stringify: {
          url: stringifyUrl,
          params: stringifyParams,
        },
      },
      Journeys: {
        path: 'journeys/:title/:url/:params?',
        parse: {
          url: parseUrl,
          params: parseParams,
        },
        stringify: {
          url: stringifyUrl,
          params: stringifyParams,
        },
      },
    },
  },
};

export default linking;
